import React, { useEffect, useContext } from 'react'
import { NavigateWayContext } from '../store/NavigateWayContext';
import '../styles/addRoom.css'
import { useLocation, useNavigate, useparams } from 'react-router-dom'
import chevron from '../img/chevron.svg'
import axiosInstance from '../auth/axiosInstance'
import { Button } from '../components/button/button'
import { Search } from '../components/search/search'
import noCount from '../img/noCountRoom.png'
import { dynamicReduce } from '../components/dynamicReduce'
import { Header } from '../components/header/header';
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';
function TableRacks() {
    const navigate = useNavigate()
    const location = useLocation()
    const [data, setData] = React.useState([])
    const [months, setMonths] = React.useState([])
    const [initialData, setInitialData] = React.useState([])
    const params = location.state

    // VARIAVEL GLOBAL QUE CONTROLA A NAVEGAÇÃO ENTRE AS PÁGINAS DO FLUXO
    const { navigateWay, setNavigateWay } = useContext(NavigateWayContext);
    // navigateWay = {site: '/', room: '', map: '', newcount: '', diagram: ''}

    function getData() {
        axiosInstance(`count/room/${params.idRoom}`)
            .then(async res => {
                let arr = res.data.map(element => {
                    return {
                        ...element,
                        month: `${new Date(element.createdAt).toLocaleDateString('en', { month: 'long' })}/${new Date(element.createdAt).getFullYear()}`
                    }

                });
                setMonths(await dynamicReduce('month', arr, {}))
                setInitialData(res.data)
                setData(res.data)
            })
            .catch(err => console.log(err))
    }

    React.useEffect(() => {
        getData()
    }, [])

    return (
        <section className='tech-body'>
            <Header line>
                <Breadcrumb
                    site={true}
                    room={true}
                    map={true}
                    newcount={false}
                    diagram={false}
                />
            </Header>
            
            <div className='search-area'>
                <Search initialData={initialData} set={setData} style={{ border: '1px solid #0F0742', boxShadow: '0 0 0', width: '75%' }} placeholder='Search' />
                <Button 
                    style={{ width: '30%', background: '#0F0742', color: '#fff' }} 
                    onClick={() => (
                        setTimeout(() => {
                            setNavigateWay(prevState => ({
                                ...prevState,
                                newcount: `/site/${params.dc}/${params.id}/new`,
                                state: location.state
                            }));
                            navigate(`/site/${params.dc}/${params.id}/new`, {state: location.state})
                        }, 100)
                    )} 
                    label={'New Count'}
                />
            </div>
            <h1 className='title-totalracks'>Historical Racks</h1>
            <section className='table-estructure-rack'>
                {
                    data.length > 0 ?
                        Object.keys(months).map((valueMonth) => {
                            if (data.filter(el => `${new Date(el.createdAt).toLocaleDateString('en', { month: 'long' })}/${new Date(el.createdAt).getFullYear()}` === valueMonth).length > 0) {
                                return (
                                    <>
                                        <h2 className='title-months-rack-page'>{valueMonth}</h2>
                                        <table className='table-estructure-rack_table'>
                                            <thead>
                                                <tr>
                                                    <th>Cages</th>
                                                    <th>Added</th>
                                                    <th>Churned</th>
                                                    <th>Client</th>
                                                    <th>Date</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data.map(value => {
                                                        if (`${new Date(value.createdAt).toLocaleDateString('en', { month: 'long' })}/${new Date(value.createdAt).getFullYear()}` === valueMonth) {
                                                            return (
                                                                <tr style={{ background: 'rgba(63, 57, 104, 0.20)' }}>
                                                                    <td>{value.cage ? value.cage : 'No Data'}</td>
                                                                    <td>{value.added}</td>
                                                                    <td>{value.churned}</td>
                                                                    <td>{value.client.client}</td>
                                                                    <td>{new Date(value.createdAt).toLocaleDateString()}</td>
                                                                    <td style={value.status === 0 ? { color: '#273CF6' } : value.status === 1 ? { color: '#59975C' } : { color: '#B73D3D' }}>{value.status === 0 ? 'In Query' : value.status === 1 ? 'Approved' : 'Disapproved'}</td>
                                                                    {/* <td className='img-table-racks-historical'><img onClick={() => getOne(value.id)} src={chevron} alt='chevron' /></td> */}
                                                                </tr>
                                                            )
                                                        } else {
                                                            return null
                                                        }
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </>
                                )
                            } else return null
                        })
                        :
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '5%' }}>
                            <img src={noCount} alt='no count' />
                        </div>
                }
            </section>
        </section >
    )
}

export default TableRacks